export { default as Component } from "./Interpretation.svelte";
export const modes = ["dynamic"];
